// extracted by mini-css-extract-plugin
module.exports = {"container":"Slider_container__2mfJ6","track":"Slider_track__3Qe6q","thumb":"Slider_thumb__2-YTX"};